import React from 'react'
import './Footer.css'

export function Footer(): React.JSX.Element{
    return(
        <div id="footer">
            Thomas Glenn, Benjamin Wootten, Magnus Culley
            <br></br>
            <a href="https://www.vecteezy.com/free-vector/blue-minimalist-background">Blue Minimalist Background Vectors by Vecteezy</a>
        </div>
    )
}